import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { theme } from 'transfix-ui'

export const TRANSITION = `all 150ms ${theme.transitions.easing.sharp}`

export enum FormActions {
  dismiss = 'dismiss',
  confirm = 'confirm',
}

export const SERVICES: TSelectOpt[] = [
  { value: 'lumper_service', label: 'Lumper' },
  { value: 'pallet_jack', label: 'Pallet Jack' },
  { value: 'escort_service', label: 'Escort Service' },
  { value: 'overnight_parking', label: 'Overnight Parking' },
  { value: 'freezer_blast', label: 'Freeze Blast' },
  { value: 'drivers_lounge', label: 'Drivers Lounge' },
  { value: 'scale_on_site', label: 'Scale on Site' },
]

export const EQUIPMENT_TYPES: TSelectOpt[] = [
  { value: 'dry_van', label: 'Dry Van' },
  { value: 'reefer', label: 'Reefer' },
  { value: 'open_deck', label: 'Flatbed' },
]

export const REQUIREMENTS: TSelectOpt[] = [
  { value: 'twic_card', label: 'TWIC Card' },
  { value: 'driver_unload', label: 'Driver Unload' },
]

export const WAREHOUSE_TYPES: TSelectOpt[] = [
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'retail', label: 'Retail/Store' },
  { value: 'crossdock', label: 'Crossdock' },
]

export const RELAY_PAYMENTS_NETWORK_STATUSES: TSelectOpt[] = [
  { value: 'in_network', label: 'In Network' },
  { value: 'out_of_network', label: 'Out of Network' },
  { value: 'unknown', label: 'Unknown' },
]
